export const isImage = (url) => {
    let res = false;
    if(url.match(/\.(jpeg|jpg|gif|png)$/) != null){ res = true}
    if(url ==="image.jpg") { res = false;}
    if(url ==="null") { res = false;}
    if(url ==="undefined") { res = false;}
    return(res);
}
export const sortObj = (obj) =>{
    let toObj = Object.keys(obj);
    toObj.sort(function(a, b) { 
        var x=obj[a].priority,
            y=obj[b].priority;
        return y - x;
    });
    return toObj;
}
export const is = {
    empty:(v)=>{
        return (v.search('=undefined') !==-1)? true : false;
    }
     
}
export const getSettings = (group, props) =>{
    if(typeof props[group]==="object"){
        return (item)=> {
           return props[group][item] || item + "=undefined";
        }
    }else{
        return (item)=> {
            return group + "=undefined";
         };
    }
}

export const Image= (img)=>{
    // 11-4-2019 10:40pm
    if(typeof img ==="string"){
        var pattern = new RegExp('/', 'ig');
        var count = (img.match(pattern) || []).length;
        if(count !==0) {
            return img;
        } 
        let ext = img.search('.png') !== -1? '.png' : '.jpg'; 
        let filename = img.split('/').pop();
            filename = filename.split(ext)[0];
            return `https://firebasestorage.googleapis.com/v0/b/weyoopos.appspot.com/o/media%2F${filename}${ext}?alt=media`;
    }
    return null;
}
export const hasImage = (img)=>{
    let has = false;
    if(typeof img ==="string"){
        [".jpg",".png",".gif",".svg"].map(find=>{ has = img.search(find) !== -1? true : has; return null; })
    }
    return has;
}
// FORM VALIDATOR 
export const validateForm = (values,form,callback) =>{
    let size = Object.keys(form).length;
    let validates = 0;
    let errors  = "Please Insert:";
    let count   = 0;
    Object.keys(form).map((field)=>{
         count++;
         if(values[field]){
             if(field==='item2'){
                if(values[field].match(/^\d{11}$/)) {
                    validates++;
                }else{
                    errors += " * " + form[field];
                }  
             }else{
                validates++;
             }
         }else{
            errors += " * " + form[field];
         }
         if(size === validates){
             callback(true,null);
         }else{
             if(count === size){
                callback(false,errors);
             }
         }
        return false; 
    });
   
}
export const siteCurrency = (curr)=>{
    const c = "$";
    return (val)=>{
      if(parseInt(val,10) ===0){
         return "";
      }else{
         return c + "" + val
      }
    }
}
export const Head ={
    title:(title)=>{
        document.title = title;
        return title.split("|")[1];
    }
} 
export const siteLink =(to)=>{
    var vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    if(vars.biz){
        return to + "?biz="+vars.biz;
    }else{
        return to;
    }
    
}

export const postMessage = (client, params,callback) =>{
    let form =  {};
        form.phone = `${params.phone1}${params.phone2}${params.phone3}`;
        form.fullname = params.item1;
        form.cellphone = params.cellphone;
        form.email = params.item3;
        form.text = params.item6;
        form.body = 'NEW MESSAGE FROM: '+form.fullname +' https://garciatech.com/3894939939993993';

    fetch("https://weyoopos.firebaseio.com/inbox/" +client+ "/messages.json",{
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // no-referrer, *client
        body: JSON.stringify(params), // body data type must match "Content-Type" header
    }).then(()=>{
        // AFTER SAVING POST TEXT
        fetch("https://us-central1-weyoopos.cloudfunctions.net/garciatechMessages/api/create",{

            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
            },
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // no-referrer, *client
            body: JSON.stringify({to:form.cellphone,body:form.body}), // body data type must match "Content-Type" header
        });
        callback(true);
    });
    callback(false); 
}

export const parseDomain = (url) =>{
    const parts = url.split(".");
    return (parts.length > 1)? parts[0] : url;
}
export const gotData  = (props) =>{
    if(props.app !==null && props.fetched === true) return true;
    return false;
}
export const backRouter = (path)=>{
    let p = path;
    let now = path;
    if(path !=="/") { 
        path = path.split("/");
        path = path.slice(0,-1);
        p = "";
        for (var i = 0; i < path.length; i++) {
            if(i!==0) p += "/" + path[i];
        }
     }
    // Need to work if this is reach from  
    return {link:p, showbtn: (now ==="/")? false: true};
    
}





// WEBPACK FOOTER //
// ./src/helpers/index.js